/*Copyright © SITA INC Ireland, SITA INC USA, SITA Switzerland Sarl 2025. Confidential. All rights reserved.*/
import { Injectable, signal } from '@angular/core';
import { SignInData } from '../model/signInData';
import { Router } from '@angular/router';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import {
  Observable,
  Subject,
  map,
} from 'rxjs';
import { Constants } from '../constants';
import { LoginDetails } from '../../login/login.component';

@Injectable({
  providedIn: 'root',
})
export class AuthenticationService {
  private readonly isAuthenticated = signal(false);
  isLoggedIn: boolean = false;
  private readonly sessionExp = new Subject();
  public $sessionExpired = this.sessionExp.asObservable();

  constructor(private readonly router: Router, private readonly httpService: HttpClient) {}

  authenticate(signInData: SignInData): Observable<LoginDetails> {
    return this.httpService
      .post<any>(environment.apiUrl + Constants.LOGIN_URI, signInData)
      .pipe(
        map((response) => {
          this.isLoggedIn = true;
          this.isAuthenticated.set(true);
          return response;
        })
      );
  }

  changePassword(currentPassword?: string|null , newPassword?: string|null ) {
    return  this.httpService.post(environment.apiUrl+Constants.CHANGE_PASSWORD,{
      "old_password": currentPassword,
      "new_password": newPassword
    })
  }


  getIsAuthenticated(): boolean {
    return this.isAuthenticated();
  }


}
